import { LocationSelect, EventSearch } from 'search'
import Tabs, { Tab } from 'shared/components/Tabs'
import { SEARCH_MODE_EVENTS, SEARCH_MODE_MONTHLY, BOOKABLE_SEASON_TICKET_ONLY } from 'search/constants'
import featureToggles from 'shared/featureToggles'

import { getInitSearchMode } from 'map/helpers'

const TABS = [
    {
        label: 'input.tab.search.park',
        mode: getInitSearchMode(window.COUNTRY_PURCHASE_FLOW),
        children: (
            <LocationSelect
                placeholder={<T>input.placeholder.search.park</T>}
                size="large"
                icon="pin-indigo-bookable-act"
            />
        ),
    },
    {
        label: 'input.tab.search.event',
        mode: SEARCH_MODE_EVENTS,
        children: <EventSearch size="large" icon="ticket" />,
    },
    {
        label: 'input.tab.search.subscription',
        mode: SEARCH_MODE_MONTHLY,
        children: (
            <LocationSelect
                placeholder={<T>input.placeholder.search.subscription</T>}
                size="large"
                icon="pin-indigo-bookable-act"
                bookableMode={BOOKABLE_SEASON_TICKET_ONLY}
            />
        ),
    },
]

const getActiveTab = parkingMode => {
    const index = TABS.findIndex(({ mode }) => parkingMode === mode)

    return index === -1 ? 0 : index
}

const Search = ({ setParkingMode, parkingMode }) =>
    featureToggles.hasEventFlow ? (
        <Tabs tabStyle="tabs" activeTab={getActiveTab(parkingMode)}>
            {TABS.map(({ label, mode, children }) => (
                <Tab key={mode} label={<T>{label}</T>} onClick={() => setParkingMode(mode)}>
                    {children}
                </Tab>
            ))}
        </Tabs>
    ) : (
        <LocationSelect size="large" icon="pin-indigo-bookable-act" />
    )

export default Search
